
export const edelstahlgelaender_mit_glas =
    {
        category: 'Geländer mit Glas',
        modell: [
            {
                index: '',
                kind: 'Geländer mit Glas',
                img: '',
                titel: '',
                form: '',
                muster: '',
                price: 450
            }
        ],
        data_description: [
            {
                image: '',
                file: '',
                own_modell_file: '',
                own_modell_image: '',
                description: '',
                isUploadData: false
            }
        ],
        layout: '',
        wrapper: [{wrapper1: 0, wrapper2: 0, wrapper3: 0, wrapper4: 0, wrapper5: 0, wrapper6: 0}],
        steps: [
            [[false], [false], [false], [false], [false], [false], [false], [false], [false]],
            {
                visited: [0],
                active_steps: []

            }
        ],
        dimensions: [
            {
            width_1: '',
            width_2: '',
            width_3: '',
            single_elements: [],
            width_total: '',
            height: '',
            kind_dimension: ''
          },
        ],
        colors: [
            {
                kind_of_color: '',
                wish_color: '',
                color_index: '',
                color: '',
            }
        ],
        form_handrail: [
            {
                handtrail_form: '',
                endkappe: ''
            }
        ],
        pfosten_form: '',
        befestigungsart: '',
        glasart: '',
        allVisitedSteps: false,
        is_merkliste: false
    }
